import {
    httpPost, httpGet
} from "/config/request.js"

export function selDecorateShopStyleSetApi(params) {
    return httpPost('/prod/decorateInfo/selDecorateShopStyleSet', params)
}